import { CloudDone, CloudOffSharp } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

const NewsIconComponent = ({ document, openNews }) => {
  return (
    <div>
      <Tooltip
        arrow
        title={document.error ? "Ver errores" : "Formulario correcto"}
      >
        {document.error ? (
          <CloudOffSharp
            color="error"
            onClick={() => openNews(document)}
            sx={{ cursor: "pointer" }}
          />
        ) : (
          <CloudDone
            color="success"
            onClick={() => openNews(document)}
            sx={{ cursor: "pointer" }}
          />
        )}
      </Tooltip>
    </div>
  );
};

export default NewsIconComponent;
